import { useContext } from "react";
import { BottomSheetContext } from "../providers/BottomSheetProvider";

export default function useBottomSheet() {
  return useContext(BottomSheetContext);
}
